import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/home/index' //首页
import front from './modules/frontRouter'
import manageruser from './modules/managerUserRouter'
import room from './modules/roomRouter'
import user from './modules/userRouter'
Vue.use(Router)

export default new Router({
    mode: "history",
    routes: [{
        path: '/',
        name: 'index',
        component: index,
        meta: {
            title: '首页'
        }
    }, ...front, ...manageruser, ...room, ...user]
})





// WEBPACK FOOTER //
// ./src/router/index.js